import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import EventForm from './EventForm';
//
// Компонент для редактирования мероприятия
//
const EventEdit = () => {
    const { t } = useTranslation();
    const event = useSelector(state => state.event);

    return (
        <div>
		    <EventForm event={event}/>
            <p>
                <NavLink to={'/cabinet/eventview/' + event._id}>{t('eventform.back')}</NavLink>
            </p>
        </div>
	);
};

export default EventEdit;
